"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeNavigation = exports.CollapseState = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const icons_material_1 = require("@mui/icons-material");
const classnames_1 = __importDefault(require("classnames"));
const tree_navigation_styles_1 = require("./tree-navigation.styles");
const common_1 = require("../common");
const icons_1 = require("../../../icons");
const utils_1 = require("../../../utils");
var CollapseState;
(function (CollapseState) {
    CollapseState["Collapse"] = "collapse";
    CollapseState["Expand"] = "expand";
})(CollapseState || (exports.CollapseState = CollapseState = {}));
const TreeNavigation = ({ treeData, excluded, included, setExcluded, setIncluded, expandOverride, parentIds, debouncedSearchTerm, terminalNodeInteractionOnly, simpleRootNode, }) => {
    const [listExpanded, setListExpanded] = (0, react_1.useState)([]);
    const [filteredNodes, setFilteredNodes] = (0, react_1.useState)(treeData);
    const [pending, startTransition] = (0, react_1.useTransition)();
    (0, react_1.useEffect)(() => {
        const updatedTree = (0, utils_1.buildTreeFromFilteredItems)(treeData, debouncedSearchTerm);
        setFilteredNodes(updatedTree);
    }, [debouncedSearchTerm, treeData]);
    (0, react_1.useEffect)(() => {
        startTransition(() => {
            if (expandOverride === CollapseState.Collapse) {
                setListExpanded([]);
            }
            if (expandOverride === CollapseState.Expand) {
                setListExpanded(parentIds);
            }
        });
    }, [expandOverride, parentIds]);
    const renderTreeNode = (0, react_1.useCallback)((treeNode) => {
        var _a;
        const rootParent = !treeNode.parentId;
        const terminalNode = !((_a = treeNode.children) === null || _a === void 0 ? void 0 : _a.size);
        return (react_1.default.createElement(tree_navigation_styles_1.StyledTreeItem, { className: (0, classnames_1.default)({ 'root-parent': rootParent, 'terminal-node': terminalNode }), hasChildren: treeNode.children.size > 0, key: treeNode.id, nodeId: treeNode.id, label: react_1.default.createElement(react_1.default.Fragment, null, (!terminalNodeInteractionOnly || terminalNode)
                && (react_1.default.createElement(tree_navigation_styles_1.StyledButtonsWrapper, null, react_1.default.createElement(tree_navigation_styles_1.StyledCheckbox, { handleChange: () => setIncluded(treeNode.id), checked: included.includes(treeNode.id) }), react_1.default.createElement(tree_navigation_styles_1.StyledExcludeButton, { onClick: () => setExcluded(treeNode.id) }, react_1.default.createElement(icons_1.ExcludeIcon, { stroke: excluded.includes(treeNode.id) ? ui_components_1.baseColors.red : ui_components_1.baseColors.primaryBlueMed600 })))), react_1.default.createElement(tree_navigation_styles_1.StyledTitle, null, react_1.default.createElement(ui_components_1.Typography, { className: "node-title", variant: "subtitle1", accent: true }, treeNode.title), (!simpleRootNode || !rootParent) && react_1.default.createElement(ui_components_1.Typography, { color: "textSecondary" }, treeNode.id))) }, treeNode.children.size ? [...treeNode.children.values()].map((child) => renderTreeNode(child)) : null));
    }, [included, excluded, setExcluded, setIncluded, terminalNodeInteractionOnly]);
    const renderedTreeNodes = (0, react_1.useMemo)(() => { var _a; return (filteredNodes ? (_a = [...filteredNodes.values()]) === null || _a === void 0 ? void 0 : _a.map((node) => (renderTreeNode(node))) : []); }, [filteredNodes, renderTreeNode]);
    const handleToggle = (_, nodeIds) => {
        setListExpanded(nodeIds);
    };
    return (react_1.default.createElement(tree_navigation_styles_1.StyledTree, { defaultCollapseIcon: pending ? react_1.default.createElement(common_1.ProcessingSpinner, null) : react_1.default.createElement(icons_material_1.ExpandMore, { color: "primary", fontSize: "large" }), defaultExpandIcon: pending ? react_1.default.createElement(common_1.ProcessingSpinner, null) : react_1.default.createElement(icons_material_1.ChevronRight, { color: "primary", fontSize: "large" }), expanded: listExpanded, onNodeToggle: handleToggle, disableSelection: true }, renderedTreeNodes));
};
exports.TreeNavigation = TreeNavigation;
exports.default = exports.TreeNavigation;
